<template>
  <div id="app">
        

    <router-view/>

    <uiwu-footer />
  </div>
</template>
<script>


  import uiwuFooter from '@/components/uiwuFooter/uiwuFooter.vue';
  export default{
    components:{uiwuFooter},
    data(){
      return {}
    }
  }
</script>

<style lang="scss">
  @import './uiwu.scss';
</style>
